import { useEffect, useState } from "react"
import { useNavigate } from "react-router";

export default function ReservationEngine() {
  
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let now = new Date() 
    let next = new Date() 

    next.setDate(now.getDate() + 2);
    setCheckIn(now.toLocaleDateString('en-CA'));
    setCheckOut(next.toLocaleDateString('en-CA'));
  }, [])

  const search = () => {
    navigate(`reservar?checkin=${checkIn}&checkout=${checkOut}`)
  }

  return (
    <div className="absolute flex flex-wrap justify-center bottom-12 left-0 w-full z-20 px-4">
      <div className="max-w-3xl bg-white rounded-lg overflow-hidden ">
        <label className="inline-block px-5 w-5/12 pb-2 border-b md:w-auto md:border-b-0" htmlFor="checkIn">Check-in:</label>
        <input className="border-x py-2 px-5 w-7/12 outline-none border-b md:w-auto md:border-b-0" type="date" id="checkIn" value={checkIn} onChange={e => setCheckIn(e.target.value)} />
        <label className="inline-block px-5 w-5/12 md:w-auto" htmlFor="checkIn">Check-out:</label>
        <input className="border-x py-2 px-5 w-7/12 md:w-auto outline-none" type="date" id="checkIn" value={checkOut} onChange={e => setCheckOut(e.target.value)} />
        <button className="bg-stone-500 py-2 border border-blue-600 px-12 text-white w-full md:w-auto" onClick={search}>BUSCAR</button>
      </div>
    </div>
  )
}